import React, { type FC } from 'react';
import type { FuseResult } from 'fuse.js';
import styled from 'styled-components';
import { Grid, Paragraph } from '../UIKit/system';
import { SearchCard, SearchCardProps } from './search-card';
import Container from '../container';

interface SearchResultSectionProps {
  heading: string;
  results: FuseResult<SearchCardProps>[] | null;
}

export const ResultsSection: FC<SearchResultSectionProps> = (props) => {
  const { heading, results } = props;

  if (!results || results.length === 0) return null;

  return (
    <Container large>
      <Grid maxWidth={['audo', 'auto', '70%']}>
        <Heading>{heading}</Heading>
        <Grid gridGap={20}>
          {results.map((result) => (
            <SearchCard key={result.item.id} {...result.item} />
          ))}
        </Grid>
      </Grid>
    </Container>
  );
};

const Heading = styled(Paragraph).attrs(() => ({
  color: ['white', 'white', 'black'],
  fontSize: [16, 16, 18],
  fontWeight: 'bold',
  pb: 24
}))`
  [aria-busy='true'] & {
    color: transparent;
  }
`;
